var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('Tooltip', {
    attrs: {
      "theme": _vm.theme,
      "max-width": _vm.maxWidth,
      "content": _vm.content,
      "placement": _vm.placement,
      "transfer": _vm.transfer
    }
  }, [_c('Icon', {
    style: {
      color: _vm.color
    },
    attrs: {
      "size": _vm.size,
      "type": _vm.iconType
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }